import { render, staticRenderFns } from "./CabinetTemplate.vue?vue&type=template&id=320d294b"
import script from "./CabinetTemplate.vue?vue&type=script&lang=ts"
export * from "./CabinetTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports